import { Box, Checkbox, TeamAvatar, UserAvatar } from '@pocketlaw/tetris';
export function ManualApproverItem(props) {
    const { type, name, selected, onChange } = props;
    return (<Box alignItems="center" justifyContent="space-between">
      {type === 'team' && <TeamAvatar size="sm" title={name}/>}
      {type === 'user' && <UserAvatar size="sm" title={name}/>}
      <Checkbox checked={selected} onChange={onChange}/>
    </Box>);
}
